import React from 'react';

const CheckoutBillingInfo = ({
  billingData,
  setBillingData,
  billingErrors,
  onSubmit,
  loading
}) => {
  return (
    <div className="checkout-form">
      <h2 className="checkout-title">Fatura Bilgileri</h2>
      
      <form onSubmit={onSubmit} className="form-section">
        {billingErrors.general && (
          <div style={{ 
            padding: '15px', 
            marginBottom: '20px', 
            backgroundColor: '#ffebee', 
            border: '1px solid #f44336', 
            borderRadius: '4px', 
            color: '#c62828' 
          }}>
            {billingErrors.general}
          </div>
        )}

        <div style={{ marginBottom: '30px' }}>          
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                Ad <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                value={billingData.name}
                onChange={(e) => setBillingData({ ...billingData, name: e.target.value })}
                className="form-control"
                placeholder="Adınız"
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  border: billingErrors.name ? '1px solid #f44336' : '1px solid #ddd', 
                  borderRadius: '4px' 
                }}
              />
              {billingErrors.name && (
                <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                  {billingErrors.name}
                </span>
              )}
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                Soyad <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                value={billingData.surname}
                onChange={(e) => setBillingData({ ...billingData, surname: e.target.value })}
                className="form-control"
                placeholder="Soyadınız"
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  border: billingErrors.surname ? '1px solid #f44336' : '1px solid #ddd', 
                  borderRadius: '4px' 
                }}
              />
              {billingErrors.surname && (
                <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                  {billingErrors.surname}
                </span>
              )}
            </div>
          </div>

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
              TC Kimlik No <span style={{ color: 'red' }}>*</span>
            </label>
            <input
              type="text"
              value={billingData.identityNumber}
              onChange={(e) => setBillingData({ ...billingData, identityNumber: e.target.value.replace(/\D/g, '') })}
              className="form-control"
              placeholder="11 haneli TC Kimlik No"
              maxLength="11"
              style={{ 
                width: '100%', 
                padding: '10px', 
                border: billingErrors.identityNumber ? '1px solid #f44336' : '1px solid #ddd', 
                borderRadius: '4px' 
              }}
            />
            {billingErrors.identityNumber && (
              <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                {billingErrors.identityNumber}
              </span>
            )}
          </div>

        </div>

        {/* Fatura Adresi */}
        <div style={{ marginBottom: '30px' }}>          
          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
              Adres <span style={{ color: 'red' }}>*</span>
            </label>
            <textarea
              value={billingData.address}
              onChange={(e) => setBillingData({ ...billingData, address: e.target.value })}
              className="form-control"
              placeholder="Mahalle, Sokak, Bina No, Daire No"
              rows="3"
              style={{ 
                width: '100%', 
                padding: '10px', 
                border: billingErrors.address ? '1px solid #f44336' : '1px solid #ddd', 
                borderRadius: '4px',
                resize: 'vertical'
              }}
            />
            {billingErrors.address && (
              <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                {billingErrors.address}
              </span>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '15px', marginBottom: '15px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                Şehir <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                value={billingData.city}
                onChange={(e) => setBillingData({ ...billingData, city: e.target.value })}
                className="form-control"
                placeholder="İstanbul"
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  border: billingErrors.city ? '1px solid #f44336' : '1px solid #ddd', 
                  borderRadius: '4px' 
                }}
              />
              {billingErrors.city && (
                <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                  {billingErrors.city}
                </span>
              )}
            </div>

            <div>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: 500 }}>
                Ülke <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type="text"
                value={billingData.country}
                onChange={(e) => setBillingData({ ...billingData, country: e.target.value })}
                className="form-control"
                placeholder="Turkey"
                style={{ 
                  width: '100%', 
                  padding: '10px', 
                  border: billingErrors.country ? '1px solid #f44336' : '1px solid #ddd', 
                  borderRadius: '4px' 
                }}
              />
              {billingErrors.country && (
                <span style={{ color: '#f44336', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                  {billingErrors.country}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* Form Actions */}
        <div className="form-actions" style={{ marginTop: '30px' }}>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', padding: '12px', fontSize: '16px' }}
          >
            {loading ? 'Kaydediliyor...' : 'Devam Et'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CheckoutBillingInfo;

